import { useSelector } from 'react-redux';
import { SharedStoreState } from '../types';

export const selectMoveableFrame = (state: SharedStoreState) =>
	state.moveableFrame;

export const useSelectMoveableFrame = () => useSelector(selectMoveableFrame);
